module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["option-list"]
  }, _vm._l((_vm.oList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: ["option-item"],
      class: [item.checked && 'option-item-current'],
      on: {
        "click": function($event) {
          _vm.checkChange(item)
        }
      }
    }, [_c('text', {
      staticClass: ["text"]
    }, [_vm._v(_vm._s(item.title))])])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-182e5bf8!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-date-cycle-picker/option-list-circle.vue
// module id = 582
// module chunks = 0 1